import http from '@/plugins/http';
import { isHTTPError } from '@/services/errors';

export async function isAuthenticated(): Promise<200 | 401 | 403 | 500> {
  try {
    await http.get('/auth/check_privileges');
    return 200;
  } catch (error) {
    if (isHTTPError(error)) {
      if (error.response.status === 401 || error.response.status === 403)
        return error.response.status;
    }
    return 500;
  }
}
